import { render, staticRenderFns } from "./AddTaskModal.vue?vue&type=template&id=4f11f73c&scoped=true"
import script from "./AddTaskModal.vue?vue&type=script&lang=js"
export * from "./AddTaskModal.vue?vue&type=script&lang=js"
import style0 from "./AddTaskModal.vue?vue&type=style&index=0&id=4f11f73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f11f73c",
  null
  
)

export default component.exports